import moment from "moment";
import {baseUrl} from '../../configuration/clientConfig';

module.exports = {   
    baseUrl:baseUrl,
    sessionExpiryTime:60*60*1000,
    COLORS: {
        MainBlue: '#005F7D',
        AccentBlue: '#00AAC3',
        Red: '#E13C65',
        Orange: '#FF6919',
        White:'#ffffff',
        Black:'#000000',
        Green:'#4CAF50',
        Green700:'#388E3C',
        Yellow:'#FFEB3B',
    },
    errMessages:{
        recordCannotCertify:'This record cannot be certified until earlier records are certified',
        invalidActivity:'Invalid Activity',
        printError:'At least 1 activity should be there to Print'
    },
    hosModals:{
        Certified_Modal:'Certified_Modal',
        Certify_Modal:'Certify_Modal',
        Comments_Modal:'Comments_Modal',
        payperiod_modal:'Payperiod_Modal'
    },
    routes:{
        defaultAdminRoute:'/noncertified',
        defaultEmpRoute:'/workdays',
        defaultEmpHosRoute:'/userhoslogsworkdays',
        defaultFRARoute:'/frareport',
    },
    PrintPDF: {
        "Orientation": "landscape",
        "Unit": "pt",
        "PageNumber": 1,
        getPrintColumns(role, category){
            if(role == 'Employee'){
                return ["Activity Name", "Start Time", "End Time", "Misc Time"];
            } else {
                if(category == 'AT'){
                    return ["Id", "Type", "Table", "Field", "Old Value", "New Value","Updated Time"];
                } else if(category == 'U'){
                    return ["Division", "Employee ID", "Job Type", "Employee Name", "Service Date", "Phone", "HOS", "TOS", "Outlaw"];
                }
                else if (category == 'C'){
                    return ["Division", "Employee ID", "Job Type","Employee Name", "Service Date", "Phone", "HOS", "TOS", "Certify Date","Outlaw"];                    
                }else if (category == 'FRA' || category == 'AHL'){
                    return ["Employee ID","Employee Name", "Service Date", "Job Type", "HOS","Certify Date","Comment","Status"];                    
                }
                else if(category == 'S14'){
                    return ["Employee ID","Employee Name", "Service Date", "Job Type", "14 Series", "6 Series"];
                } else {
                    return ["Division", "Employee ID", "Job Type", "Employee Name", "Service Date", "System HOS", 
                            "System TOS", "Adjusted HOS","Adjusted TOS","Differential HOS",
                            "Differential TOS","Claim Date"];
                }
            }
            
        }
    },
    postHeaders: (token='') => {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Authorization' : 'Bearer '+ (token ? token : localStorage.getItem('id_token'))
        }
    },
    getHeaders: (token='') => {
        return {
            'Authorization' : 'Bearer '+ (token ? token : localStorage.getItem('id_token'))
        }
    },
    actionTypes:{
        HASTUS_UPDATE: 'HASTUS_UPDATE',
        ACTIVITY_START_CHANGING:'ACTIVITY_START_CHANGING',
        ACTIVITY_FINISHED_CHANGING:'ACTIVITY_FINISHED_CHANGING',
        WORKDAY_TOGGLED_SUCCESS:'WORKDAY_TOGGLED_SUCCESS',
        TAB_CHANGE_SUCCESS: 'TAB_CHANGE_SUCCESS',
        HIDE_NOTES_SUCCESS:'HIDE_NOTES_SUCCESS',
        SET_NOTES_SUCCESS:'SET_NOTES_SUCCESS',
        GET_NOTES_SUCCESS:'GET_NOTES_SUCCESS',
        ACTION_INPROCESS:'ACTION_INPROCESS',
        LOCATION_SUCCESS:'LOCATION_SUCCESS',
        NOTIFICATION_SUCCESS:'NOTIFICATION_SUCCESS',
        DEFAULTWORKDAY_SUCCESS:'DEFAULTWORKDAY_SUCCESS',
        GETPRINTDATA_SUCCESS:'GETPRINTDATA_SUCCESS',
        PRINT_PROGRESS:"PRINT_PROGRESS",
        COVER_LOADING:"COVER_LOADING",
        FILTER_SUCCESS:'FILTER_SUCCESS',
        RESET_FILTER_SUCCESS:'RESET_FILTER_SUCCESS',
        ITEMS_IS_LOADING: "ITEM_IS_LOADING",
        ITEMS_HAS_ERRORED: "ITEMS_HAS_ERRORED",
        ITEMS_SUCCESS: "FETCH_DATA_SUCCESS",
        WORKDAY_LOADING:"WORKDAY_LOADING",
        WORKDAY_SUCCESS: "WORKDAY_SUCCESS",
        FRA_WORKDAY_SUCCESS: "FRA_WORKDAY_SUCCESS",
        EDIT_SUCCESS: "EDIT_SUCCESS",
        ADD_SUCCESS: "ADD_SUCCESS",
        ACTIVITY_ERR_SUCCESS:"ACTIVITY_ERR_SUCCESS",
        ACTIVITY_EDIT_SUCCESS:"ACTIVITY_EDIT_SUCCESS",
        SET_ACTIVITYERR_SUCCESS:"SET_ACTIVITYERR_SUCCESS",
        ROLE_SUCCESS:"ROLE_SUCCESS",
        SHOWMODAL_SUCCESS:"SHOWMODAL_SUCCESS",
        HIDEMODAL_SUCCESS:"HIDEMODAL_SUCCESS",
        UPDATE_SUCCESS: "UPDATE_SUCCESS",
        DELETE_SUCCESS: "DELETE_SUCCESS",
        CHANGES_SUCCESS:"CHANGES_SUCCESS",
        PAGINATION_SUCCESS: "PAGINATION_SUCCESS",
        LOGIN_SUCCESS:"LOGIN_SUCCESS",
        LOGIN_PROGRESS:"LOGIN_PROGRESS",
        LOGIN_ERROR:"LOGIN_ERROR",
        LOGOUT_SUCCESS:"LOGOUT_SUCCESS",
        ACTIVITIES_SUCCESS:"ACTIVITIES_SUCCESS",
        CLEAR_WORKDAY_SUCCESS:"CLEAR_WORKDAY_SUCCESS",
        POST_IN_PROGRESS:"POST_IN_PROGRESS",
        ERR_IN_ADD_WORKDAY:"ERR_IN_ADD_WORKDAY",
        ADD_WORKDAY_SUCCESS:"ADD_WORKDAY_SUCCESS",
        RESET_WORKDAY_SUCCESS:"RESET_WORKDAY_SUCCESS",
        E_AND_D_ACTIVITIES_SUCCESS: "E_AND_D_ACTIVITIES_SUCCESS",
        CONFIGURATION_SUCCESS : 'CONFIGURATION_SUCCESS',
        CHANGE_CONFIGURATION : 'CHANGE_CONFIGURATION',
        UPDATE_CONFIGURATION : 'UPDATE_CONFIGURATION',
        HOSLOG_SUCCESS_ADMIN : 'HOSLOG_SUCCESS_ADMIN',
        HOSLOG_DETAIL_SUCCESS_ADMIN : 'HOSLOG_DETAIL_SUCCESS_ADMIN',
        POPUP_MESSAGE: 'POPUP_MESSAGE',
        POPUP_MESSAGE_CLOSE : 'POPUP_MESSAGE_CLOSE',
        HOSLOG_SUCCESS : 'HOSLOG_SUCCESS',
        GET_SHIFT_TIMING : 'GET_SHIFT_TIMING',
        SHOW_LOGOUT_TIMER:'SHOW_LOGOUT_TIMER',
        CLOSE_LOGOUT_TIMER:'CLOSE_LOGOUT_TIMER',
        UPDATE_WORKDAY_LOG_SUCCESS : 'UPDATE_WORKDAY_LOG_SUCCESS',
        EMPLIST_SUCCESS : "EMPLIST_SUCCESS",
        SERIES_WORKDAY_SUCCESS : "SERIES_WORKDAY_SUCCESS",
        SERIES14_WORKDAY_SUCCESS : "SERIES14_WORKDAY_SUCCESS",//added a constant for series > 14
        SERIES_IS_LOADING : "SERIES_IS_LOADING",
        UPDATE_TOGGLE_SIDEBARMENU : "UPDATE_TOGGLE_SIDEBARMENU",
        OFFDUTY_CHECK : "OFFDUTY_CHECK",
        OFFDUTY_CHECK_FOR_TODAY:"OFFDUTY_CHECK_FOR_TODAY",
        UPDATE_SERVER_TIME : "UPDATE_SERVER_TIME",
        DEADEHEAD_WARNING:"DEADEHEAD_WARNING",
        SHOWMODAL_MANUAL:"SHOWMODAL_MANUAL",
        UPDATE_ACTIVE_MENU:"UPDATE_ACTIVE_MENU",
        SET_AZURE_MSAL:"SET_AZURE_MSAL",
        SET_AZURE_USER_ACC:"SET_AZURE_USER_ACC",
        SET_HOME_PATH:"SET_HOME_PATH",
        SET_AZURE_ERROR:"SET_AZURE_ERROR",
        IMPERSONATE_LOGIN_START: 'IMPERSONATE_LOGIN_START',
        FRA_WORKDAY_LOADING:"FRA_WORKDAY_LOADING",
    },
    actionUrls:{
        GET_NOTES:'getnotes',
        GET_ACTIVITIES: '/getactivities',
        WORKDAYS_URL: '/workdays',
        WORKDAY_URL: '/workday',
        POST_NOTE_URL:'/notes/postnote/',
        ADD_NEW_WORKDAY_URL:'/workdays/addnewworkday',
        POST_WORKDAY_URL:'/workdays/postworkday/',
        loginurl:"/login",
        ADMIN_URL: '/adminWorkdays',
        ADMIN_NCNP_URL: '/adminworkdaysncnp',
        RECERTIFY_WORKDAY_URL:'/workdays/recertifyWorkday',
        E_AND_D_ACTIVITIES_URL: '/workdays/eAndD',
        GET_CONFIGURATIONS:'/getconfigurations',
        UPDATE_CONFIGURATION_URL : '/configurations/postconf',
        ADMIN_HOS_LOGS_URL:'/adminhoslogs',
        EMPLOYEE_HOS_LOGS_URL:'/userhoslogs',
        HOS_LOG_DETAILS:'/hosdetails',
        FRA_DETAILS : '/fradetails',
        SHIFT_TIMING: '/shift',
        POST_HOSLOG_WORKDAY_URL:'/hoslogs/postworkday/',
        GET_FRA_LIST:'/fra_reports_list',
        EMPLOYEE_SERIES_URL:'/userserieslogs',
        GET_ALL_USER_SERIES:'/alluserserieslogs',
        GET_EMPLOYEE_LIST:'/get_employee_list',
        GET_FAQ_PDF:'/ispdfavailable',
        FILE_UPLOAD:'/upload-avatar',
        GET_FRA_WORKDAY_DETAILS:'/fraworkdaydetails/'
    },
    configurationstype : {
        NCNP_STATUS : 'ncnpstatus'
    },
    miscActivity:['Diversion', 'Time Paid Not Worked Overtime', 'Locomotive Engineer Stipend'],
    roles:{
        EMPLOYEE_ROLE: "Employee",
        ADMIN_ROLE: "Admin",
        FRA_ROLE:"FRA"
    },
    UNCERTIFIED: 'U',
    //UNCERTIFIEDPRE16: 'UP16',
    CERTIFIED: 'C',
    CLAIM: 'L',
    PENDING_CLAIM:'PC',
    ADMIN_HOS_LOG:'AHL',
    FRA_REPORT:'FRA',
    EMPLOYEE_HOS_LOG:'EHL',
    ACCEPTED_CLAIM: 'AC',
    AUDIT_TRAIL:'AT',
    REJECTED_CLAIM: 'RC',
    MANUALLY_UPDATE:'MU', //aravind //manual update
    OUTLAW:'O',
    CONFIGURATIONS:'CFG',
    SERIES14:'S14',
    UNCERTIFIED_TITLE: 'Non Certified Pay Details',
    HOS_LOG_TITLE: 'HOS Logs',
    CERTIFIED_TITLE: 'Certified Pay Details',
    CLAIM_TITLE: 'Claim',
    PENDING_TITLE: 'Pending Claims',
    REJECTED_TITLE: 'Rejected Claims',
    ACCEPTED_TITLE:'Accepted Claims',
    MANUALLY_TITLE:'Manually Update Hastus',
    OUTLAW_TITLE:'Outlaw',
    AUDIT_TRAIL_TITLE:'Audit Trail',
    CONFIGURATIONS_TITLE:'Configurations',
    CERTIFY_TXT: "Certify ",
    MODAL_TITLE: "Pay Details",
    MODAL_TITLE_OLD: "Hours of Service",
    REJECT: "reject",
    checkAgainst: 719,
    timeFormat:"HH:mm A",
    time12Format:"hh:mm A",
    dateFormat:'MM/DD/YYYY',
    DefaultDateTimeFormat: "MM/DD/YYYY h:mm A",
    certifyByAdmin:false,
    getConvertedDateTime: function (date) {
        const dateString = moment(date).format(this.DefaultDateTimeFormat);
        return (moment(dateString, this.DefaultDateTimeFormat, true).isValid()) ? dateString : '-';
    },
    getComponentTitle: function(route){
        var compTitle = 'No Title';
        var route = route ? route : '';
        if(route){
            if(route == this.CLAIM){
                compTitle = this.PENDING_TITLE;
            } else if(route == this.UNCERTIFIED){
                compTitle = this.UNCERTIFIED_TITLE;
            } else if(route == this.CERTIFIED){
                compTitle = this.CERTIFIED_TITLE;
            } else if(route == this.PENDING_CLAIM){
                compTitle = this.PENDING_TITLE;
            } else if(route == this.REJECTED_CLAIM){
                compTitle = this.REJECTED_TITLE;
            } else if(route == this.ACCEPTED_CLAIM){
                compTitle = this.ACCEPTED_TITLE;
            } else if(route == this.OUTLAW){
                compTitle = this.OUTLAW_TITLE;
            } else if(route == this.AUDIT_TRAIL){
                compTitle = this.AUDIT_TRAIL_TITLE;
            }else if(route == this.MANUALLY_UPDATE){ //aravind //newly added manually update hastus route
                compTitle = this.MANUALLY_TITLE;
            } 
            else if(route == this.CONFIGURATIONS){
                compTitle = this.CONFIGURATIONS_TITLE;
            }
            else if(route == this.ADMIN_HOS_LOG || route == this.EMPLOYEE_HOS_LOG ){
                compTitle = this.HOS_LOG_TITLE;
            }
        } else {
            compTitle = compTitle;
        }
        return compTitle;
    },
    logTypes : {
        DUTY_TYPE : [
            {id: 1, name: '1'},
            {id: 2, name: '2'},
            {id: 3, name: 'Non-Covered-Service'}
        ],
        DEADHEAD_TYPE : [
            {id: 1, name: 'Personal Auto'},
            {id: 2, name: 'Taxi'},
            {id: 3, name: 'Train'},
            {id: 4, name: 'Company Vehicle'},
            {id: 5, name: 'Other-specify in comments'}
        ],
        OCCUPATION : [
            {id: 1, name: 'Conductor'},
            {id: 2, name: 'Assistant Conductor'},
            {id: 3, name: 'Engineer'}
        ]
    },
    Menus : [
        {id: 1, Name : "HOS"},
        {id: 2, Name : "Series"},
        {id: 3, Name : "NCNP"}
    ],
    COVERED_SERVIE : [
        "Availability","Football","FuelCrew","Herder","HouseEng","PowerWash","Protect","ProtectUniform","ReadvSwitcher",
        "SwitchTender","WAD","WashCrew","WorkTrain","TermSwitcher","PHYS-PAID"
    ],
    NON_COVERED_SERVICE : [
        "CTC","ETC","ERC","COB","PHYS","QUA","CRC","TTC","Absence","LIMBO"
    ],
    GROUPS : ['FRA HOS','HOS Management','EMPLOYEE'],
    authCompMessage: 'Please wait!!!  Azure authentication in progress.',
    HOS_COVERED_SERVICE:[
        "Availability","Football","FuelCrew","Herder","HouseEng","PowerWash","Protect","ProtectUniform","ReadvSwitcher",
        "SwitchTender","WAD","WashCrew","WorkTrain","TermSwitcher","PHYS-PAID","Sign-on","Sign-off"
    ],
    CONFIRM_TXT:"Confirm",
    HISTORICAL_LOGS:"HistoricalLogs",
    PAYDETAILS:"PAYDETAILS"
};